import React, {
  forwardRef, useState, useImperativeHandle, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../formEnums/formValidation';
import FormInputTypes from '../formEnums/formInputTypes';
import Button, { ButtonType, ButtonTheme, ButtonSize } from '../../atoms/button/button';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { IconType } from '../icon/icon';
import { update } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
let updateTimeout = null;
/**
 * Basic HTML input
 */
const InputText = forwardRef((props, ref) => {
  const {
    id,
    name,
    type,
    validation,
    placeholder,
    value,
    onChange,
    className,
    pattern,
    disabled,
    autoComplete,
    autoFocus,
    multiple,
    multiline,
    limitSpecialCharacters,
    onBlur,
    importButton,
    configFileImport,
    configFile,
    blockInput,
    fieldToImport,
    min,
    max,
    avoidAutofill,
    hasTooltip,
  } = props;
  const [valueState, setValueState] = useState(value === null ? '' : value);
  const [disabledState, setDisabledState] = useState();
  const { delayedUpdate } = configFile ? configFile : 100;

  // console.log(disabled);

  const handleChange = (event) => {
    const newValue = event.target.value;
    if (pattern === undefined || pattern.test(newValue) || newValue === '') {
      setValueState(newValue);
      if (delayedUpdate) {

        event.persist();
        onEventChange(() => {

          onChange(event)

        });
      }
      else {
        onChange(event)
      }

    }
  };
  const handleBlur = (event) => {
    // if(updateTimeout){
    //   onChange(event);
    // }
    onBlur();
  }

  const onEventChange = (callback) => {
    if (delayedUpdate)
      clearTimeout(updateTimeout);
    updateTimeout = setTimeout(() => {
      callback();
    }, 800);
  }
  const handleSpecialCharacter = e => {
    if (e.key === "/" || e.key === "," || e.key === "$" || e.key === "%" || e.key === "\\" || e.key === "'") {
      e.preventDefault();
    }
  };

  const addTags = event => {
    if (event.key === "Enter" && event.target.value !== "") {
      event.target.value = "";
      setValueState([...valueState, event.target.value]);
      onChange(event);
    }
  };
  useImperativeHandle(ref, () => ({
    updateValue(newValue) {
      setValueState(newValue === null ? '' : newValue);
    },
  }));
  const handleOnCloseImport = (e) => {
    if (e && e[0][fieldToImport]) {
      let newValue = '';
      if (valueState == "")
        newValue = e[0][fieldToImport];
      else
        newValue = valueState + "," + e[0][fieldToImport];
      setValueState(newValue);
      const Ev = {
        type: "change",
        target: { value: newValue }
      };
      onChange(Ev);
    }
  }
  let inputElement = (
    <>
      {avoidAutofill && <form>
        <input
          name={name}
          id={id}
          type={type}
          onKeyDown={limitSpecialCharacters ? handleSpecialCharacter : undefined}
          className={`form-control border-${validation}  ${className}`}
          placeholder={placeholder}
          value={valueState}
          min={min}
          max={max}
          onChange={handleChange}
          onKeyUp={event => multiple ? addTags(event) : ''}
          autoComplete={autoComplete === true ? '' : 'no'}
          disabled={(disabled ? disabled : disabledState) || (blockInput ? blockInput : false)}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          ref={ref}
          onClick={(e) => e.stopPropagation()}
          onFocus={(e) => e.currentTarget.select()}
          onBlur={handleBlur}
        />
      </form>}
      {!avoidAutofill &&
        <input
          name={name}
          id={id}
          type={type}
          onKeyDown={limitSpecialCharacters ? handleSpecialCharacter : undefined}
          className={`form-control border-${validation}  ${className}`}
          placeholder={placeholder}
          value={valueState}
          min={min}
          max={max}
          onChange={handleChange}
          onKeyUp={event => multiple ? addTags(event) : ''}
          autoComplete={autoComplete === true ? '' : 'no'}
          disabled={(disabled ? disabled : disabledState) || (blockInput ? blockInput : false)}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          ref={ref}
          onClick={(e) => e.stopPropagation()}
          onFocus={(e) => e.currentTarget.select()}
          onBlur={handleBlur}
        />
      }
    </>
  );

  if (multiline) {
    inputElement = (
      <>
        {importButton && <div style={{ float: 'left' }}>
          <LoadFromCatalogButton
            id={'button-' + id}
            onClose={handleOnCloseImport}
            label={name}
            configFile={configFileImport}
            buttonText={importButton}
            icon={IconType.SEARCH}
            buttonTheme={ButtonTheme.PRIMARY}
          />
        </div>}
        {/* {saveCatalog && <div style={{float:'right'}}>
          <Button
            
            id={`button-save`}
            type={'submit'}
            theme={ButtonTheme.PRIMARY}
          >
            {saveCatalog}
          </Button>
        </div>} */}
        <textarea
          name={name}
          id={id}
          type={type}
          onKeyDown={limitSpecialCharacters ? handleSpecialCharacter : undefined}
          className={`form-control border-${validation}  ${className}`}
          placeholder={placeholder}
          value={valueState}
          onChange={handleChange}
          onKeyUp={event => multiple ? addTags(event) : ''}
          autoComplete={autoComplete === true ? '' : 'no'}
          disabled={(disabled ? disabled : disabledState)}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          ref={ref}
          onClick={(e) => e.stopPropagation()}
          onFocus={(e) => e.currentTarget.select()}
          onBlur={handleBlur}
          rows={5}
        >
        </textarea>
      </>);
  }

  if (!hasTooltip || !valueState) {
    return inputElement;
  }
  return (
    <OverlayTrigger
      placement="top"
      overlay={(
        <Tooltip id={`tooltip-${id || name}`}>
          {valueState}
        </Tooltip>
      )}
    >
      <span>
        {inputElement}
      </span>
    </OverlayTrigger>
  );
});

InputText.propTypes = {
  /**
   * id of input field
   */
  id: PropTypes.string,
  /**
   * Name of input field
   */
  name: PropTypes.string.isRequired,
  /**
   * HTML input type, it is a FormInputTypes.TEXT_INPUT enum
   */
  type: PropTypes.oneOf(Object.values(FormInputTypes.TEXT_INPUT)),
  /**
   * Input form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Placeholder inside the HTML input
   */
  placeholder: PropTypes.string,
  /**
   * Set the value inside the HTML input
   */
  value: PropTypes.node,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * custom css class
   */
  className: PropTypes.string,
  /**
   * The input regular expression to control
   */
  pattern: PropTypes.instanceOf(RegExp),
  /**
   * Enable browser autocomplete
   */
  autoComplete: PropTypes.bool,
  /**
   * Enable browser autocomplete
   */
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onBlur: PropTypes.func,
  hasTooltip: PropTypes.bool,
};

InputText.defaultProps = {
  id: '',
  type: FormInputTypes.TEXT_INPUT.TEXT,
  validation: FormValidation.PENDING,
  className: '',
  placeholder: '',
  value: '',
  onChange: () => { },
  pattern: undefined,
  autoComplete: true,
  disabled: false,
  autoFocus: false,
  onBlur: () => { },
  hasTooltip: false,
};

export default InputText;
